export default __webpack_public_path__ + "static/media/expired.866c4db6.png";